import React from 'react';

function Privacy() {
  return (
    <div className="container">
      <article className="page">
        <h1>Privacy Policy</h1>
        <p className="updated">Last updated: April 7, 2026</p>

        <p>
          Your privacy matters to us. This policy explains what data
          <strong> Construction Calculator</strong> collects, why we
          collect it, and how we keep it safe.
        </p>

        <h2>1. Information we collect</h2>
        <ul>
          <li>
            <strong>Anonymous usage data</strong> — pages opened, features used
            and crash reports — collected via Firebase Analytics and Crashlytics
            to help us improve the app.
          </li>
          <li>
            <strong>Device data</strong> — device model, operating system
            version, language and approximate region.
          </li>
          <li>
            <strong>Push notification token</strong> — provided by Firebase
            Cloud Messaging if you allow notifications.
          </li>
        </ul>
        <p>We do not collect your name, phone number or email unless you choose to send us a message.</p>

        <h2>2. How we use the data</h2>
        <ul>
          <li>To diagnose bugs and improve calculator accuracy.</li>
          <li>To understand which features people find most useful.</li>
          <li>To send occasional update or offer notifications (if enabled).</li>
        </ul>

        <h2>3. Advertising</h2>
        <p>
          The free version of the app shows ads through Google AdMob. AdMob
          may use your device's advertising identifier to show more relevant
          ads. You can reset or limit this identifier in your phone settings.
        </p>

        <h2>4. Data sharing</h2>
        <p>
          We do not sell your personal data. We share limited, anonymous data
          only with the service providers that power the app (Firebase, Google
          AdMob), and only as needed for them to function.
        </p>

        <h2>5. Children's privacy</h2>
        <p>
          The app is not directed to children under 13. We do not knowingly
          collect personal information from children.
        </p>

        <h2>6. Your choices</h2>
        <ul>
          <li>You can disable analytics and personalized ads in your device settings.</li>
          <li>You can turn off push notifications at any time.</li>
          <li>You can request deletion of any data we hold by emailing us.</li>
        </ul>

        <h2>7. Changes to this policy</h2>
        <p>
          We may update this policy occasionally. The latest version will
          always be available on this page.
        </p>

        <h2>8. Contact us</h2>
        <p>
          Questions or concerns? Reach out at{' '}
          <a href="mailto:support@fairappsstore.com">support@fairappsstore.com</a>.
        </p>
      </article>
    </div>
  );
}

export default Privacy;
